import { render } from "./lightbox-manager.vue?vue&type=template&id=5c28d810"
import script from "./lightbox-manager.vue?vue&type=script&lang=js"
export * from "./lightbox-manager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__